(() => {
  'use strict';

  function optimizeImages() {
    const firstProductImage = document.querySelector('.cl-product__media--main img');
    if (firstProductImage) {
      firstProductImage.loading = 'eager';
      firstProductImage.fetchPriority = 'high';
      firstProductImage.decoding = 'async';
    }

    document.querySelectorAll('img:not([decoding])').forEach((image) => image.setAttribute('decoding', 'async'));
  }

  function improveMobileMenu() {
    const menu = document.querySelector('.cl-mobile-nav');
    if (!menu) return;

    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      }
    });

    menu.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
  }

  function addRevealAnimations() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = document.querySelectorAll('.cl-home .cl-section, .cl-card, .cl-offer-card, .cl-product-story article, .cl-product-trust__grid article, .cl-page__content > *, .cl-contact__card');
    targets.forEach((target) => target.classList.add('cl-reveal'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cl-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach((target) => observer.observe(target));
  }

  function createProductLightbox() {
    const images = [...document.querySelectorAll('.cl-product__media img')];
    if (!images.length) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'cl-lightbox';
    dialog.setAttribute('aria-label', 'Agrandissement de l’image produit');
    dialog.innerHTML = '<button type="button" class="cl-lightbox__close" aria-label="Fermer">×</button><img alt="">';
    document.body.appendChild(dialog);

    const dialogImage = dialog.querySelector('img');
    const closeButton = dialog.querySelector('.cl-lightbox__close');

    images.forEach((image) => {
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'Agrandir cette image produit');
      const open = () => {
        dialogImage.src = image.currentSrc || image.src;
        dialogImage.alt = image.alt || 'Image produit CANILUME';
        dialog.showModal();
      };
      image.addEventListener('click', open);
      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });
    });

    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  function init() {
    optimizeImages();
    improveMobileMenu();
    addRevealAnimations();
    createProductLightbox();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
